import "../index.css";
import { PencilIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FormattedDate } from "@/components/columns/FormattedDate";
import { ImageGallery } from "@/components/ImageGallery";
import type { IInspectorHud } from "@/types/users-inspectors";
import { Card, Heading, IconButton, LabelValue, Row, Tooltip } from "@/ui-kit";

type IProps = {
  hudDetails: IInspectorHud;
  onEdit?: () => void;
};

export const HudDetailsCard = ({ hudDetails, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "128px";

  return (
    <Card className="profile-card">
      <Card.Body>
        <Row gap="xl" alignmentVertical="top">
          <div className="profile-card__image-gallery">
            <ImageGallery
              imageUrls={[
                hudDetails.frontImageUrl,
                hudDetails.backImageUrl,
              ].filter((url): url is string => !!url)}
            />
          </div>
          <div className="profile-card__details">
            <Row gap="sm">
              <Heading level={3} tone="default">
                {t("label.hud_details")}
              </Heading>

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="neutral"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.hud_id_number")}
                  value={hudDetails.documentNumber}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.issuance_date")}
                  value={<FormattedDate value={hudDetails.issuanceDate} />}
                  labelWidth={labelWidth}
                />
                <LabelValue
                  label={t("label.expiry_date")}
                  value={<FormattedDate value={hudDetails.expiryDate} />}
                  labelWidth={labelWidth}
                />
              </div>
            </div>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};
